module.exports = __webpack_public_path__ + "static/media/DDAEA719-47A3-43E6-8597-832FAC69FFE0.a247edfa.JPG";